import { useState, useEffect, createContext, useContext, useCallback, useMemo } from "react";
import { apiGetMe, apiLogin, apiRegister, apiLogout, trackEvent } from "../api/client";
import { gtagEvent } from "../utils/analytics";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try { setUser(await apiGetMe()); }
    catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = useCallback((email, password) =>
    apiLogin(email, password).then((result) => {
      setUser(result);
      trackEvent('dealer_login', { user_email: email });
      gtagEvent('dealer_portal_login', { user_email: email, role: result?.role });
      return result;
    })
  , []);

  const register = useCallback((userData) =>
    apiRegister(userData).then((result) => { setUser(result); return result; })
  , []);

  const logout = useCallback(async () => {
    await apiLogout();
    setUser(null);
  }, []);

  const actions = useMemo(() => ({ login, register, logout, checkAuth }), [login, register, logout, checkAuth]);
  const contextValue = useMemo(() => ({ user, loading, ...actions }), [user, loading, actions]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
